export function isSomeEnum<T extends Record<string, string | number>>(enumObject: T) {
    return (token: unknown): token is T[keyof T] =>
        Object.values(enumObject).includes(token as T[keyof T]);
}
